import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import { PATIENTS_LIST_LENGTH } from '../../constants';
import { useSearchPatients } from '../../hooks';
import * as selectors from '../../selectors';
import ActivePatientsList from '../PatientsList/ActivePatientsList';
const SearchPatientsList = ({ id, className, onPatientClick })=>{
    const search = useSelector(selectors.searchSelector(id));
    const omitPatient = useSelector(selectors.activePatient);
    const patients = useSearchPatients(search, {
        omitPatient,
        maxLength: PATIENTS_LIST_LENGTH,
        emptyDefault: true
    });
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                height: 0
            },
            animate: patients.length === 0 ? {
                display: 'none'
            } : {
                height: 'auto',
                display: 'block'
            },
            exit: {
                height: 0
            },
            className: className,
            children: /*#__PURE__*/ _jsx(ActivePatientsList, {
                id: id,
                patients: patients,
                styleModifier: "halfSpace",
                onPatientClick: onPatientClick
            })
        })
    });
};
export default SearchPatientsList;
